import * as axios from "axios";
import { copyText } from "@opendate-app/setlist";
import { toastError, toastSuccess } from "../../shared/toastHelper";

const STATUS_DONE = { publish: "published", unpublish: "unpublished", archive: "archived" };

export const landingPageUrl = (teamId, product) => `${window.location.origin}/m/${teamId}/${product.slug}`;

const attr = (value) => String(value).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;");

export const embedCode = (teamId, product) => {
  const baseUrl = window.location.origin;
  return `<script src="${baseUrl}/packs/od_embed.js"></script>
<iframe src="${baseUrl}/m/${teamId}/${product.slug}/widget"
  id="od-membership-${product.id}-iframe" title="${attr(product.name || "Membership")}"
  scrolling="no" allowpaymentrequest="true" allow="payment" style="border:none; width:
  1px; min-width: 100%;" height="600px;"></iframe>
<script>
  document.addEventListener('DOMContentLoaded', function() {
    ODEmbed("od-membership-${product.id}-iframe");
  });
</script>`;
};

export const changeStatus = async ({ teamId, product, csrfToken, action }) => {
  try {
    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
    const response = await axios.post(`/teams/${teamId}/membership_products/${product.id}/${action}`);
    toastSuccess(`Membership ${STATUS_DONE[action]} successfully.`);
    if (action === "archive") window.location.href = `/teams/${teamId}/membership_products`;
    return response.data;
  } catch (error) {
    const errorMessages = (error.response && error.response.data && error.response.data.errors) || [`Failed to ${action} membership.`];
    toastError(errorMessages[0]);
    return null;
  }
};

export const copyWithToast = async (text, label) => {
  if (await copyText(text)) {
    toastSuccess(`${label} copied to clipboard`);
  } else {
    toastError(`Could not copy ${label.toLowerCase()}. Please copy it manually.`);
  }
};
